<p-toast [baseZIndex]="100000" key="toast-login"></p-toast>

<div class="container justify-content-center login-layout">
  <div id="login-display" [hidden]="showMFAInfo" [@fadeLeft]>
    <app-login
      [language]="language"
      [languages]="languages"
      [returnUrl]="returnUrl"
      (setLanguageMethod)="setLanguage($event)"
      (toggleShowMFAInformationMethod)="toggleShowMFAInformation($event)"
    ></app-login>
  </div>

  <div id="login-QR-info-display" class="row container px-4" [hidden]="!showMFAInfo" [@fadeRight]>
    <app-mfa
      [currentLanguage]="currentLanguage"
      (toggleShowMFAInformationMethod)="toggleShowMFAInformation($event)"
    ></app-mfa>
  </div>
</div>
